import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect-navegador-ie',
  templateUrl: './redirect-navegador-ie.component.html'
})
export class RedirectNavegadorIeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    sessionStorage.clear();
  }

}
